import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-select-measurement-mode-dialog',
    templateUrl: './select-measurement-mode-dialog.component.html',
    styleUrl: './select-measurement-mode-dialog.component.scss',
    standalone: false
})
export class SelectMeasurementModeDialogComponent {
  public selectMode: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SelectMeasurementModeDialogComponent>
  ) {
    this.selectMode = this.data.selectMode;
  }

  isSelectMode(mode: string): boolean {
    return this.selectMode === mode;
  }

  changeMode(mode: string): void {
    this.selectMode = mode;
    this.dialogRef.close(this.selectMode);
  }
}
